import { request } from 'react-common'
import { PlatformUser } from 'types'
import { ActivityRecord } from '@/api/models/activityRecord'
import type { Objective } from '@/api/models/objective'

export interface ObjectiveRecord {
  id: string
  score: number
  maxScore: number
  normalizedScore: number
  grade: string
  progress: number
  objective: Objective
  user: PlatformUser
  created: string
  started: string
  submitted: string
  finished: string
  objectiveWorkflowId?: string
  activityRecord: ActivityRecord
  passed: boolean
  protectResults: boolean
}

export class ObjectiveRecordApi {
  private static readonly api = request('objective-records/:id?')

  static query(queries: Record<string, any>) {
    return this.api.get({ url: { id: 'query' }, query: queries }).then((res) => res.body.data as ObjectiveRecord[])
  }

  static get(id: string) {
    return this.api.get({ url: { id } }).then((res) => res.body as ObjectiveRecord)
  }
}
